<template>
  <div v-if="dashboardData">
    <div class="row top-bar-dashboard">
      <div class="col-md-9 logo">
        <img class="logo-img"
             src="/img/logo-workfix.png"
             alt="Logo">
      </div>
      <div class="col-md-3 time-date">
        {{ time|timeanddate }}
      </div>
    </div>
    <div class="row first-row">
      <div class="col-md-5 left-side">
<!--                <button @click="startMusic.play()">start</button>-->
<!--                <button @click="stopMusic.play()">stop</button>-->
        <weekly-placings-table
            :placementsAdded="getPlacementsAdded"
            :placementsDeleted="getPlacementsDeleted"
            :totalPlacements="getTotalPlacements"
        >
        </weekly-placings-table>
      </div>
      <div class="col-md-7">
        <div class="row right-side">
          <div class="col-md-4 gif">
            <result-indicator-gif :totalResult="getTotalPlacements"></result-indicator-gif>
          </div>
          <div class="col-md-8 vacancies-list">
            <customerStatistics :statistics="getLastStats"></customerStatistics>
          </div>
        </div>
      </div>
    </div>
    <div class="row second-row">
      <div class="col-md-5 cards">
        <cards :dashboardData="dashboardData" :weekNumber="getWeek"></cards>
      </div>
      <div class="col-md-7 candidates-list">
        <candidates-table :dashboardData="dashboardData"></candidates-table>
      </div>
    </div>
  </div>
</template>

<script>
// https://audiotrimmer.com/

import axios from 'axios';
import weeklyPlacingsTable from './../../components/dashboard/weeklyPlacingsTable';
import cards from './../../components/dashboard/cards';
import candidatesTable from './../../components/dashboard/candidatesTable';
import ResultIndicatorGif from '../../components/dashboard/resultIndicatorGif';
import customerStatistics from '../../components/dashboard/customerStatistics';


export default {
  name: 'DASHBOARD',
  components: {
    ResultIndicatorGif,
    customerStatistics,
    weeklyPlacingsTable,
    cards,
    candidatesTable
  },
  firestore() {

    let searchParams = new URLSearchParams(window.location.search)

    this.token = searchParams.get('token')
    this.department = searchParams.get('department')

    return {
      dashboardEvents: this.$FB.collection('dashboardEvents')
          .where('department', '==', this.department)
    };
  },
  data() {
    return {
      time: moment(),
      token: null,
      department: null,
      startMusic: null,
      stopMusic: null,
      championsLeagueAnthem: null,
      audioPlaying: false,
      ikLoopOverTrack: null,
      dashboardEvents: [],
      dashboardData: null,

      playPromise: null,
      weekNumber: null
    };
  },
  methods: {
    getDashboardData() {

      axios.get(this.$CLOUD_API + '/dashboard?hash=' + this.$HASH + `&token=${this.token}&department=${this.department}`).then(res => {
        if (res.status == 200) {
          this.dashboardData = res.data;
        }
      });
    }

  },
  computed: {
    getLastStats() {
      return _.first(this.dashboardData.weeklyStats);
    },
    getCurrentWeeksPlacements() {
      let placements = this.dashboardData.placements;
      let currentWeek = moment().startOf('week').add(1, 'day');
      let nextWeekDate = moment().add(1, 'week').startOf('week').add(1, 'day');
      placements = _.filter(placements, (placement) => {
        let placementDate = moment(placement.startDate);
        return (placementDate.isAfter(currentWeek) || placementDate.isSame(currentWeek)) && placementDate.isBefore(nextWeekDate);

      });
      placements.map(placement => {
        placement.candidate = _.find(this.dashboardData.candidates, {'id': placement.candidateId});
        placement.vacancy = _.find(this.dashboardData.vacancies, {'id': placement.vacancyId});
        return placement;
      });

      return placements;
    },
    getPlacementsAdded() {
      let placements = this.dashboardData.placements;
      let placementsArray = {total: 0, week: [0, 0, 0, 0, 0]};
      _.filter(placements, (place) => {

        let placementDate = moment(place.startDate);

        if (placementDate.isAfter(moment().startOf('week')) && placementDate.isBefore(moment().endOf('week'))) {
          let placementDateDay = placementDate.day();

          placementsArray.week[placementDateDay - 1]++;
          placementsArray.total++;
        }
        return place;

      });
      return placementsArray;

    },
    getPlacementsDeleted() {
      let placements = this.dashboardData.placements;

      let placementsArray = {total: 0, week: [0, 0, 0, 0, 0]};
      _.filter(placements, (place) => {
        let endDate = moment(place.endDate);
        if (place.endDate && endDate.isAfter(moment().startOf('week')) && endDate.isBefore(moment().endOf('week'))) {
          let placementDate = moment(place.endDate).day();
          placementsArray.week[placementDate - 1]--;
          placementsArray.total--;
        }
        return place;
      });
      return placementsArray;
    },
    getTotalPlacements() {
      let added = this.getPlacementsAdded.total;
      let lost = this.getPlacementsDeleted.total;
      return {
        added: added,
        lost: lost,
        total: added + lost
      };
    },
    recentVacancies() {
      let vacancies = this.dashboardData.vacancies;
      vacancies = vacancies.sort(function compare(a, b) {
        var dateA = new Date(a.created_at);
        var dateB = new Date(b.created_at);
        return dateB - dateA;
      });
      let sliced = vacancies.slice(0, 10);
      return sliced;
    },
    getWeek() {
      return this.time.isoWeek();
    }
  },
  watch: {
    async dashboardEvents(newV, oldV) {
      let playPromise = this.playPromise;


      let DOCID = newV[0] ? newV[0].id : null;
      newV = newV.filter((item) => {
        return !item.error;
      });
      if (newV[0]) {
        console.log(newV)
        this.getDashboardData();
        if (this.audioPlaying) {
          this.startMusic.pause();
          this.startMusic.currentTime = 0;
          this.stopMusic.pause();
          this.stopMusic.currentTime = 0;
        }
        if (newV[0].type === 'placement-added') {
          playPromise = this.startMusic.play();
          this.audioPlaying = true;
        }

        if (newV[0].type === 'placement-added-and-enddate') {
          playPromise = this.startMusic.play();
          this.audioPlaying = true;
          setTimeout(() => {
            this.startMusic.pause()
            this.startMusic.currentTime = 0
            playPromise = this.stopMusic.play();
            this.audioPlaying = true;
          }, 60000 * 5);
        }
        if (newV[0].type === 'placement-enddate') {
          playPromise = this.stopMusic.play();
          this.audioPlaying = true;
        }
      }

      if (playPromise) {
        playPromise.then(_ => {
          if (DOCID) {
            this.$FB.collection('dashboardEvents').doc(newV[0].id).delete();
          }

        }).catch(error => {
          console.error(error);
          // Auto-play was prevented
          // Show paused UI.
        });
      }
    }
  },

  created() {
    let searchParams = new URLSearchParams(window.location.search)

    this.token = searchParams.get('token')
    this.department = searchParams.get('department')
    if (this.department == 'Eindhoven') {
      this.startMusic = new Audio('start_eindhoven_scarface.mp3');
      this.stopMusic = new Audio('stop_eindhoven.mp3');
    }
   else if (this.department == 'Breda') {
      // this.startMusic = new Audio('start_breda.mp3');
      this.startMusic = new Audio('start_breda_tilburg.mp3');

      this.stopMusic = new Audio('stop_breda.mp3');
    }  else {
      this.startMusic = new Audio('start_tilburg_temp2.mp3');
      this.stopMusic = new Audio('tilburg_stop.mp3');
    }
    // this.championsLeagueAnthem = new Audio('start_tilburg_abba_thewinner.mp3');
    // this.ikLoopOverTrack = new Audio('tilburg_stop.mp3');
    var self = this;

    self.getDashboardData();

    setInterval((_) => {
      this.time = moment();
    }, 1000);

    setInterval(() => {
      let hour = this.time.hour();
      if (hour >= 7 && hour <= 20) {
        self.getDashboardData();
      }
    }, 30000);
  }
};


</script>

<style lang="scss" scoped>


.gif {
  padding-left: 50px;
  padding-right: 0px;
}

.first-row {
  height: 800px !important;
  padding-top: 70px
}

.second-row {
  height: 900px !important;
  padding-top: 170px;

  .candidates-list {
    padding-right: 0;
    padding-left: 50px !important;
    height: 900px
  }
}

.left-side, .right-side {
  padding: 10px 0px 0px 0px !important;
}

.top-bar-dashboard {
  background-color: #25b7bc;
  height: 175px;
  margin-right: 0px !important;
  margin-left: -15px;

  .time-date {
    position: fixed;
    right: 0;
    color: #ffffff;
    padding: 19px 0px 20px 80px;
    font-size: 95px;
    font-weight: bolder;

  }

  .logo {
    position: fixed;
    left: 0;
    padding: 0 12px;
    width: 500px;
    height: 175px;
    background-color: #ffffff;

    .logo-img {
      margin: 25px 5px 0px 5px;
      max-width: 100%;
      max-height: 90%;
    }
  }
}


</style>
